<template lang="pug">
    div
        .title Monto documento banco:
        v-text-field.title#document-bank-pay-input(
            :mask="mixCurrencyMask(documentBankPayment, 12)"
            placeholder="Ingrese monto pagado por Documento Banco"
            prefix="$"
            v-model="documentBankPayment"
            :rules='[rules.required, rules.validPayment, rules.notZero]'
            @input="setTransbankPayment()"
            @keyup.enter="focusVoucher"
            )
        v-divider
        .title N° de Documento banco
        v-text-field.title#transbank-voucher-num-input(solo
            placeholder="Ingrese n° de Documento Banco"
            v-model="bankDocumentNumber"
            :rules='[rules.required, rules.validVoucher]' validate-on-blur
            @keyup.enter="stopAndPrevent(e)"
            @keydown.enter="handleEmit"
            )
</template>

<script>
// Mixins:
import PaymentRules from '@/mixins/PaymentRules'
import CurrencyUtils from '@/mixins/CurrencyUtils'
import JSUtils from '@/mixins/CurrencyUtils'

import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    name: 'bank-document-payment',
    props: {},
    data: function() {
        return {
            bankDocumentNumber: '',
            documentBankPayment: '',
        }
    },
    computed: {
        ...mapState('CustomerPaymentModule', {
            paymentMethod: 'paymentMethod',
            total: state => state.total,
        }),

        ...mapGetters('CustomerPaymentModule', {
            totalToPay: 'totalToPay',
        }),

        allDocumentBankDataSet: function() {
            return (
                this.bankDocumentNumber.length > 0 &&
                this.documentBankPayment != '' &&
                parseInt(this.documentBankPayment) <= this.totalToPay
            )
        },
    },
    methods: {
        ...mapActions('CustomerPaymentModule', {
            setPayment: 'setPayment',
            setPaymentDetail: 'setPaymentDetail',
        }),
        setTransbankPayment() {
            if (parseInt(this.documentBankPayment) === 0) {
                this.setPayment('')
            } else {
                this.setPayment(this.documentBankPayment)
            }
        },
        focusVoucher() {
            setTimeout(
                () =>
                    document
                        .getElementById('transbank-voucher-num-input')
                        .focus(),
                200
            )
        },
        handleEmit() {
            if (this.allDocumentBankDataSet) this.$emit('confirm')
        },
    },
    watch: {
        /**
         * @description updates payment details in store depending of they are fully set in form or not.
         */
        /*
        allDocumentBankDataSet: function(newVal, oldVal) {
            if (newVal) {
                this.setPayment(this.documentBankPayment)
                let payload = {
                    bank_document_number: this.bankDocumentNumber,
                }
                this.setPaymentDetail(payload)
            } else {
                this.setPayment('')
                this.setPaymentDetail(null)
            }
        },
        */

        bankDocumentNumber() {
            if (this.allDocumentBankDataSet) {
                this.setPayment(this.documentBankPayment)
                let payload = {
                    bank_document_number: this.bankDocumentNumber,
                }
                this.setPaymentDetail(payload)
            } else {
                this.setPayment('')
                this.setPaymentDetail(null)
            }
        },

        documentBankPayment() {
            if (this.allDocumentBankDataSet) {
                this.setPayment(this.documentBankPayment)
                let payload = {
                    bank_document_number: this.bankDocumentNumber,
                }
                this.setPaymentDetail(payload)
            } else {
                this.setPayment('')
                this.setPaymentDetail(null)
            }
        },

        /**
         * @description If payment method changes (example: from debit to credit),
         * bankDocumentNumber data and payment data is reseted to their original values.
         */
        paymentMethod: function(newVal, oldVal) {
            this.bankDocumentNumber = ''
            this.documentBankPayment = this.totalToPay.toString()
        },
    },
    components: {},
    mixins: [PaymentRules, CurrencyUtils, JSUtils],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    mounted: function() {
        this.bankDocumentNumber = ''
        this.documentBankPayment = this.totalToPay.toString()
        this.$nextTick(() =>
            document.getElementById('document-bank-pay-input').focus()
        )
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
</style>
